import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart"
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons/faHeart"
import { HorizontalStack } from "@mallardbay/lib-react-components"
import React from "react"

import ActivityReaction from "~components/shared/activity-card/activity-reaction"
import { ReactionType } from "~graphql/generated/graphql"
import type { ActivityFieldsFragment } from "~graphql/generated/graphql"

export type ReactionIconMapItem = {
    type: ReactionType
    reactedIcon: IconDefinition
    notReactedIcon: IconDefinition
}

interface Props {
    readonly activity: ActivityFieldsFragment
}

export const REACTION_ICON_MAP = [
    {
        type: ReactionType.Like,
        reactedIcon: faHeart,
        notReactedIcon: faHeartOutline,
    },
]

export default function ActivityReactions({ activity }: Props) {
    return (
        <HorizontalStack>
            {REACTION_ICON_MAP.map((iconItem) => (
                <ActivityReaction
                    key={iconItem.type}
                    iconItem={iconItem}
                    activity={activity}
                />
            ))}
        </HorizontalStack>
    )
}
